import styled from 'styled-components';
import { P16 } from './P16';

export const P16B = styled(P16)`
  font-weight: 600;
`;
